<template>
  <div class="row mt-3 text-center justify-content-between align-items-center">
    <div class="col-6">
      <h2 class="bold-19 text-danger mb-2">
        {{ $t("home.returns") }}
      </h2>
      <h2 class="bold-24 text-danger">
        {{ modelValue?.total?.success?.return }}
      </h2>
    </div>
    <div class="col-6">
      <h2 class="bold-19 text-primary mb-2">
        {{ $t("home.changes") }}
      </h2>
      <h2 class="bold-24 text-primary">
        {{ modelValue?.total?.success?.changes }}
      </h2>
    </div>
  </div>
</template>
<script>
export default {
  name: "Orders",
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
};
</script>
